import React from 'react';
import Select, { components } from 'react-select';
import { Text } from '../';
import { colors } from './../../../tailwind';

export default class SelectMinimal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selVal: props.defaultValue,
    };
  }
  render() {
    const { defaultValue, options, width, onChange, boldFirst } = this.props;
    const { selVal } = this.state;

    const components = { DropdownIndicator };
    if (boldFirst) {
      components.SingleValue = SingleValue;
    }
    return (
      <Select
        value={selVal}
        defaultValue={defaultValue}
        onChange={selVal => {
          this.setState({ selVal });
          onChange(selVal);
        }}
        options={options}
        searchable={false}
        styles={customSelectStyles(width || 180)}
        components={components}
      />
    );
  }
}

const customSelectStyles = width => ({
  option: (base, state) => ({
    ...base,
    padding: 12,
    fontSize: 18,
    fontWeight: 300,
  }),
  control: () => ({
    // none of react-selects styles are passed to <View />
    width,
    display: 'flex',
    padding: 12,
    fontSize: 18,
    fontWeight: 300,
    justifyContent: 'space-between',
    cursor: 'pointer',
  }),
  valueContainer: () => ({
    display: 'inherit',
    justifyContent: 'space-between',
    padding: 'inherit',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: () => ({
    color: colors.grayDark,
  }),
});

const SingleValue = props => {
  const vals = props.data.label.split(' ');
  return (
    components.SingleValue && (
      <components.SingleValue {...props}>
        <Text bold inline xlarge>
          {vals[0]}{' '}
        </Text>
        <Text inline xlarge>
          {vals[1]}
        </Text>
      </components.SingleValue>
    )
  );
};

const DropdownIndicator = props =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <i className="fas fa-caret-down fa-xs" />
    </components.DropdownIndicator>
  );



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/SelectMinimal.js